import { React, useState } from "react";
import logo from "../assets/images/Logo-Usakti.png";
import { useForm } from "react-hook-form";
import { useAxios, API_URL } from "../utils/const";
import { useToast } from "../Context/ToastContext";
import { Spinner } from "react-bootstrap";
import { Message } from "primereact/message";
import toast, { Toaster } from "react-hot-toast";

const ForgotPassword = () => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const handleSave = async (formData) => {
    setLoading(true);

    const data = {
      email: formData.email,
    };

    try {
      await axiosInstance.post(`${API_URL}/forgot-password`, data);
      setLoading(false);
      toast.success("Permintaan berhasil dikirim ke email Anda");
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      toast.error(errorMessage);
    }
  };

  return (
    <div className="login-page">
      <Toaster position="top-right" />
      <div className="bg-overlay h-100">
        <div className="container-fluid h-100">
          <div
            className="row justify-content-end h-100"
            style={{ alignItems: "center", fontSize: "0.9rem" }}
          >
            <div className="col-lg-5">
              <div
                className="card shadow-lg"
                style={{
                  borderRadius: "3%",
                  paddingTop: "20px",
                  paddingBottom: "120px",
                }}
              >
                <div className="card-body">
                  <div className="header-auth d-flex mx-4 gap-3">
                    <img src={logo} alt="Usakti" height="100" />
                    <h1>Portal Presensi</h1>
                  </div>
                  <div className="row mt-5 text-center">
                    <h5>Reset Password</h5>
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <label htmlFor="" className="form-label fw-semibold">
                          Email Address
                        </label>
                        <input
                          {...register("email", {
                            required: "Email tidak boleh kosong!",
                            minLength: {
                              value: 2,
                              message: "Email minimal 2 karakter",
                            },
                            maxLength: {
                              value: 60,
                              message: "Email maximal 60 karakter",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                              message: "Email tidak valid",
                            },
                          })}
                          type="email"
                          className="form-control form-control-sm"
                        />
                        {errors.email && (
                          <Message
                            style={{ fontSize: "smaller" }}
                            className="w-100 mt-1"
                            severity="error"
                            text="Email tidak boleh kosong!"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn btn-md rounded btn-primary w-100"
                        disabled={loading}
                        onClick={handleSubmit(handleSave)}
                      >
                        {loading && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Send Reset Password Link
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
